module.exports = __webpack_public_path__ + "@/assets/img/empty-phishing.661c4774.png";